import React, { useEffect, useState } from "react";
import { noticeList } from "../../api/customerCenter";
import { toast } from "wc-toast";
import moment from "moment";
import axios from "axios";

function Announcement() {
  const [readItems, setReadItems] = useState([0]);  // 왜 쓰지???
  const [notice, setNotice] = useState([]);
  // 각 공지에 해당하는 파일 URL을 저장
  const [fileUrls, setFileUrls] = useState({});

  useEffect(() => {
    console.log("fileUrls state changed:", fileUrls);
  }, [fileUrls]);
  
  const getFileUrl = async (fileSeq) => {
    try {
      const data = { file_seq: fileSeq }
      // const response = await getfileApi(data);
      const response = await axios.post("/comm/getCommFile", data, {
        headers: {
          Accept: "application/json;charset=utf-8",
          // Authorization: `Bearer ${access_token}`,
        },
        responseType: "blob",
      })
      const contentType = response.headers['content-type'];
      const url = URL.createObjectURL(new Blob([response.data], { type: contentType }));  
      return url;
    }
    catch (error) {
      console.error(error);
    };
  };

  const handleCheckRead = async (index) => {
    if (!readItems.includes(index)) {
      const newItems = [...readItems, index];
      setReadItems(newItems);
    }
    const selectedNotice = notice[index];  
    const newFileUrls = {};    
    for (let file of selectedNotice.files) {
      const url = await getFileUrl(file.file_seq);
      newFileUrls[file.file_seq] = url;
    }
    setFileUrls(newFileUrls);
  };

  const checkReadAnnouncement = (index) => {
    return readItems.includes(index);
  };

  const callNoticeList = async () => {
    const response = await noticeList({});
    try {
      if (response?.code === 1000) {
        setNotice(response?.resultList);
      } else {
        return console.log("공지사항 불러오는데 실패했습니다.");
      }
    } catch (err) {
      return console.log("공지사항 불러오는데 실패했습니다.");
    }
  };

  useEffect(() => {
    callNoticeList();
  }, []);

  return (
    <div className="customer-service">
      <div className="accordion" id="accordionExample">
      {notice.length > 0 ? (
        notice.map((data, idx) => {
          return (
              <div
                key={data.notice_seq || idx}
                className="accordion-item"
                onClick={() => handleCheckRead(idx)}
              >
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button collapsed`}
                    type="button"
                    data-bs-toggle="collapse"
                    // data-bs-target="#collapseOne"
                    data-bs-target={`${"#collapse" + idx}`}
                    aria-expanded="false"
                    aria-controls={`${"collapse" + idx}`}
                  >
                    <div className="d-flex flex-column">
                      {/* <div className="btn-text">{data?.title}</div> */}
                       <div className="btn-text">
                        {/* <span>{notice.length-idx}. &nbsp;&nbsp;&nbsp;</span> */}
                        <span
                          style={{
                            overflowWrap: "break-word",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {data?.title}
                        </span>
                        {/* <pre className="pre-text">{data?.title}</pre> */}
                      </div>
                      <div className="btn-date">
                        {/* {data?.reg_dt
                          ? moment(data?.reg_dt).format("YYYY.MM.DD")
                          : ""} */}
                        {data?.reg_dt || ""}
                        </div>
                    </div>
                  </button>
                </h2>
                <div
                  id={`${"collapse" + idx}`}
                  className={`accordion-collapse collapse`}
                  data-bs-parent="#accordionExample"
                >
                  {/* <div className="under-accordian">{data?.contents}</div> */}
                  <div className="under-accordian">
                    {/* 파일을 클릭해서 URL을 얻어 이미지로 표시 */}
                    {data?.files?.map((file) => (
                      <div key={file.file_seq} style={{ textAlign: 'center' }}>
                        {/* 이미지 파일이 존재하면, 파일 URL로 이미지를 표시 */}
                        {fileUrls[file.file_seq] && (                          
                          <img
                            src={fileUrls[file.file_seq]}
                            alt={`File ${file.file_seq}`}
                            style={{
                              maxWidth: '100%',
                              maxHeight: '500px',
                              objectFit: 'cover',
                              margin: '5px',
                            }}
                          />
                        )}
                      </div>
                    ))}
                    <div style={{ margin:'10px 20px 0px' }}>
                      <span
                        style={{
                          overflowWrap: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {data?.contents}
                      </span>
                      {/* <pre className="pre-text">{data?.contents}</pre> */}
                      {/* {data?.contents?.split('\r\n').map((paragraph, index) => (
                        <span>{paragraph}<br/></span>
                      ))} */}
                    </div>
                  </div>
                </div>
              </div>
          );
        })
      ) : (
        <div className="mypage_wrapper ">
          <div className="container">
            <div className="card_part">
              <div className="card_box intrestCard d-flex align-items-center py-3 justify-content-center">
                공지사항이 없습니다.
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default Announcement;
